<div class="widget-header" [class.no-border]="widget?.type === 'card'">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <h3 class="text-base font-normal m-0 truncate" [id]="titleId">
        {{ widget.headerConfig?.titleKey | translate }}
      </h3>
    </div>
    <div
      class="flex flex-wrap items-center gap-2 shrink-0 max-sm:w-full max-sm:max-w-full max-sm:justify-end"
    >
      @if (
        widget.headerConfig?.showCreate &&
        showCreateButton &&
        hasCreatePermission
      ) {
        <a
          matButton
          tabindex="0"
          (click)="!lockedPatient && create.emit()"
          (keydown.enter)="!lockedPatient && create.emit()"
          (keydown.space)="!lockedPatient && create.emit()"
          [class.disabled-state]="lockedPatient"
          [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
          [attr.aria-disabled]="lockedPatient"
          role="button"
          [attr.tabindex]="lockedPatient ? -1 : 0"
          [attr.aria-label]="
            'CRUD.actions.add'
              | translate: { item: (widget.headerConfig?.titleKey | translate) }
          "
          [matTooltip]="
            'CRUD.actions.add'
              | translate: { item: (widget.headerConfig?.titleKey | translate) }
          "
        >
          {{ widget.headerConfig?.createLabel || 'Aggiungi' }}
          <mat-icon fontIcon="add"></mat-icon>
        </a>
      }
      @if (
        widget.headerConfig?.showViewAll && hasReadPermission && totalCount > 0
      ) {
        <a
          matButton
          class="edit-toggle underline!"
          tabindex="0"
          (click)="!lockedPatient && onViewAll()"
          (keydown.enter)="!lockedPatient && onViewAll()"
          (keydown.space)="!lockedPatient && onViewAll()"
          [class.disabled-state]="lockedPatient"
          [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
          [attr.aria-disabled]="lockedPatient"
          [attr.tabindex]="lockedPatient ? -1 : 0"
          [attr.aria-label]="viewAllLabel"
          [matTooltip]="viewAllLabel"
          role="button"
        >
          {{ 'GENERAL.viewAll' | translate }}
          @if (showViewAllCount && widget.id !== 'parametri') {
            ({{ totalCount }})
          }
          <mat-icon
            iconPositionEnd
            class="ms-2 material-icons-outlined"
            fontIcon="arrow_forward"
          ></mat-icon>
        </a>
      }
      @if (widget.id === 'referenti' && showStoricoRecapiti) {
        <button
          matButton
          class="edit-toggle underline!"
          type="button"
          (click)="!lockedPatient && openStoricoRecapiti.emit()"
          [class.disabled-state]="lockedPatient"
          [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
          [attr.aria-disabled]="lockedPatient"
          [attr.tabindex]="lockedPatient ? -1 : 0"
          [attr.aria-label]="'REFERENTI.vedi_storico_riferimenti' | translate"
          [matTooltip]="'REFERENTI.vedi_storico_riferimenti' | translate"
        >
          {{ 'REFERENTI.vedi_storico_riferimenti' | translate }}
        </button>
      }
      @if (widget.id === 'consensi') {
        <button
          mat-icon-button
          class="primary-icon-button"
          type="button"
          color="primary"
          (click)="!lockedPatient && refreshConsensiAsuit.emit()"
          [class.disabled-state]="lockedPatient"
          [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
          [attr.aria-disabled]="lockedPatient"
          [attr.tabindex]="lockedPatient ? -1 : 0"
          aria-label="Aggiorna consensi ASUIT"
          matTooltip="Aggiorna consensi ASUIT"
        >
          <mat-icon
            class="material-icons-outlined"
            fontIcon="refresh"
          ></mat-icon>
        </button>
      }
      @if (widget.headerConfig?.showChangeContext) {
        <a
          matButton
          class="edit-toggle underline!"
          tabindex="0"
          role="button"
          [class.opacity-50]="isLoadingChangeContext()"
          (click)="!lockedPatient && onChangeContext()"
          (keydown.enter)="!lockedPatient && onChangeContext()"
          (keydown.space)="!lockedPatient && onChangeContext()"
          [class.disabled-state]="lockedPatient"
          [style.pointer-events]="lockedPatient ? 'none' : 'auto'"
          [attr.aria-disabled]="lockedPatient"
          [attr.tabindex]="lockedPatient ? -1 : 0"
          [attr.aria-label]="
            widget.headerConfig?.changeContextLabel ||
            ('GENERAL.changeContext' | translate)
          "
          [matTooltip]="
            widget.headerConfig?.changeContextLabel ||
            ('GENERAL.changeContext' | translate)
          "
        >
          {{
            widget.headerConfig?.changeContextLabel ||
              ('GENERAL.changeContext' | translate)
          }}
          <mat-icon
            iconPositionEnd
            class="ms-2 material-icons-outlined"
            fontIcon="open_in_new"
          ></mat-icon>
        </a>
      }
    </div>
  </div>
  @if (widget.levelAllergy) {
    <div class="mt-1">
      <mat-chip
        [disableRipple]="true"
        [ngClass]="getAllergyChipClass(widget.levelAllergy)"
        [attr.aria-label]="'ALLERGIE.' + widget.levelAllergy | translate"
      >
        {{ 'ALLERGIE.' + widget.levelAllergy | translate }}
      </mat-chip>
    </div>
  }
</div>
